/* predictive-search.js — CuteDutch native predictive search voor de header-zoekbalk.
   Vervangt Boost instant-search. Gebruikt Shopify Section Rendering:
   /search/suggest?q=...&section_id=predictive-search  -> HTML van sections/predictive-search.liquid. */
(function () {
  'use strict';

  var input = document.querySelector('#top-bar-search input[name="q"]');
  if (!input) return;

  var form = input.closest('form');
  var box = document.createElement('div');
  box.className = 'cd-predict';
  box.setAttribute('data-predict', '');
  box.hidden = true;
  (form || input.parentNode).appendChild(box);

  var t = null, lastTerm = '', controller = null;

  function close() { box.hidden = true; box.innerHTML = ''; input.setAttribute('aria-expanded', 'false'); }
  function open() { box.hidden = false; input.setAttribute('aria-expanded', 'true'); }

  function fetchSuggest(term) {
    if (controller) controller.abort();
    controller = ('AbortController' in window) ? new AbortController() : null;
    var url = '/search/suggest?q=' + encodeURIComponent(term) + '&section_id=predictive-search';
    fetch(url, { signal: controller ? controller.signal : undefined })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        // Section Rendering geeft de sectie-inhoud terug; pak de zinvolle wrapper.
        var content = doc.querySelector('.cd-predict__wrap, .cd-predict__empty');
        if (!content) { close(); return; }
        box.innerHTML = '';
        box.appendChild(content);
        open();
      })
      .catch(function (e) { if (e && e.name === 'AbortError') return; close(); });
  }

  input.addEventListener('input', function () {
    var term = input.value.trim();
    if (term === lastTerm) return;
    lastTerm = term;
    clearTimeout(t);
    if (term.length < 2) { close(); return; }
    t = setTimeout(function () { fetchSuggest(term); }, 250);
  });

  input.addEventListener('focus', function () {
    if (input.value.trim().length >= 2 && box.innerHTML) open();
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  document.addEventListener('click', function (e) {
    if (!box.hidden && !box.contains(e.target) && e.target !== input) close();
  });
})();
